import React from "react";
import { ToastContext } from "@weezevent/nacre";
import { useTranslation } from "react-i18next";
import { ActionsTypes } from "../../batch-actions/batch-actions-modals/constants";

const SUCCESS_TOASTS_TRANSLATIONS = {
	[ActionsTypes.DUPLICATE_CHECKLISTS]:
		"access.checkpoint.batchChecklists.duplicateChecklists.duplicateToast.success",
	[ActionsTypes.TRANSFER_CHECKLISTS]:
		"access.checkpoint.batchChecklists.duplicateChecklists.transferToast.success",
	[ActionsTypes.LINK_WEEZ_TAG_TO_CHECKLISTS]:
		"access.checkpoint.batchChecklists.linkWeezTagToChecklists.messageAfterAction.success"
};

const ERROR_TOASTS_TRANSLATIONS = {
	[ActionsTypes.DUPLICATE_CHECKLISTS]:
		"access.checkpoint.batchChecklists.duplicateChecklists.duplicateToast.error",
	[ActionsTypes.TRANSFER_CHECKLISTS]:
		"access.checkpoint.batchChecklists.duplicateChecklists.transferToast.error",
	[ActionsTypes.LINK_WEEZ_TAG_TO_CHECKLISTS]:
		"access.checkpoint.batchChecklists.linkWeezTagToChecklists.messageAfterAction.error"
};

export const useChecklistsBatchActionsToasts = () => {
	const toaster = React.useContext(ToastContext);
	const { t } = useTranslation();

	const success = type => {
		toaster.success(t(SUCCESS_TOASTS_TRANSLATIONS[type]));
	};

	const error = type => {
		toaster.error(t(ERROR_TOASTS_TRANSLATIONS[type]));
	};

	return {
		success,
		error
	};
};
